$(function() {   

    if($('.slideSet').length > 0)
    {
        $('.slideSet').flickity({
            // options
            cellAlign: 'left',
            wrapAround: true,
            groupCells: "100%",
            contain: true,
            pageDots: true,
            prevNextButtons: true,
            imagesLoaded: true,
            adaptiveHeight: true, 
        });       
    };
    
    $('.groupSlider').flickity({
        // options
        cellAlign: 'center',
        wrapAround: true,
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        imagesLoaded: true
    });
});

